import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {Button} from '@components/ui/button/Button.tsx'

interface HeaderWrapperProps {
    $isSearchOpen?: boolean
}

export const HeaderWrapper = styled(Flexbox)<HeaderWrapperProps>`
    ${({theme: {palette, spacing, mediaQueries}, $isSearchOpen}) => css`
        box-sizing: border-box;
        background: ${palette.neutral.white};
        border-bottom: 1px solid ${palette.neutral['200']};
        padding: ${spacing * 4.5}px ${spacing * 8}px;
        display: grid;
        grid-template-columns: auto 488px;
        justify-content: space-between;
        align-items: center;

        ${mediaQueries.m} {
            padding: ${spacing * 3}px ${spacing * 4}px;
            border-bottom: none;
            background: ${palette.neutral['200']};
            grid-template-columns: ${$isSearchOpen ? '1fr' : 'auto 40px'};
        }
    `}
`

export const HeaderTitle = styled.h5`
    ${({theme}) => css`
        ${theme.typography.textXl};
        font-weight: 600;
        color: ${theme.palette.neutral['800']};
        padding: ${theme.spacing * 2}px 0;
        cursor: pointer;
    `}
`

export const MobileMenu = styled(Button)`
    ${({theme}) => css`
        padding: ${theme.spacing * 2}px;
        border-radius: 4px;
    `}
`
